import React from 'react';

interface Props
  extends Omit<React.SVGAttributes<SVGElement>, 'width' | 'height'> {
  size?: number | string;
}

const Download: React.FunctionComponent<Props> = (props) => {
  const { size = 22, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 22 22'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M4.58464 20.1663C4.32492 20.1663 4.10735 20.0783 3.93197 19.9023C3.75658 19.7263 3.66858 19.5088 3.66797 19.2497C3.66797 18.99 3.75597 18.7724 3.93197 18.597C4.10797 18.4216 4.32552 18.3336 4.58464 18.333H17.418C17.6777 18.333 17.8956 18.421 18.0716 18.597C18.2476 18.773 18.3353 18.9905 18.3346 19.2497C18.3346 19.5094 18.2466 19.7273 18.0706 19.9033C17.8946 20.0793 17.6771 20.167 17.418 20.1663H4.58464ZM11.0013 15.9268C10.8638 15.9268 10.7302 15.8962 10.6007 15.8351C10.4712 15.7739 10.3603 15.6823 10.268 15.5601L5.73047 9.73926C5.5013 9.43373 5.47075 9.1092 5.6388 8.76576C5.80685 8.42231 6.08185 8.25029 6.4638 8.24967H8.2513V2.74967C8.2513 2.48996 8.3393 2.27239 8.5153 2.09701C8.6913 1.92162 8.90885 1.83362 9.16797 1.83301H12.8346C13.0943 1.83301 13.3122 1.92101 13.4882 2.09701C13.6642 2.27301 13.7519 2.49056 13.7513 2.74967V8.24967H15.5388C15.9208 8.24967 16.1958 8.4217 16.3638 8.76576C16.5318 9.10981 16.5013 9.43428 16.2721 9.73926L11.7346 15.5601C11.643 15.6823 11.5321 15.7739 11.4019 15.8351C11.2717 15.8962 11.1382 15.9268 11.0013 15.9268ZM11.0013 13.5205L13.6596 10.083H11.918V3.66634H10.0846V10.083H8.34297L11.0013 13.5205Z'
        fill='currentColor'
      />
    </svg>
  );
};

export default Download;
